import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import OButton from "components/reusable/OButton";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import dayjs from "dayjs";
import Pagination from "../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import HROnboardingList from "./HROnboardingList";
import HROnboardingAdd from "./HROnboardingAdd";
import HROnboardingEdit from "./HROnboardingEdit";
import HROnboardingView from "./HROnboardingView";
import helpers from "utils/helpers";
import OSearch from "components/reusable/OSearch";
import OnboardingGeoIps from "components/geoAccess/OnboardingGeoIps";

const HROnboardings = () => {
  // 1. ADD fetchCompanyCompletionStatus HERE
  const { updatePageName, fetchCompanyCompletionStatus } = useContext(AuthContext);
  
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [onboardingList, setOnboardingList] = useState([]);
  const [onboardingAllList, setAllOnboardingList] = useState([]);
  const [onboardingAdd, setOnboardingAdd] = useState(false);
  const [onboardingEdit, setOnboardingEdit] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [onboardingView, setOnboardingView] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState({});

  const [filterData, setFilterData] = useState({
    category: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleEdit = (item) => {
    setCurrentItem(item);
    setOnboardingEdit(!onboardingEdit);
  };

  const handleView = (item) => {
    setCurrentItem(item);
    setOnboardingView(!onboardingView);
  };

  const handleCategory = () => {
    setOnboardingAdd(!onboardingAdd);
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const allOnboarding = async (data) => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData;
      
      // Handle page decrement on delete/status change
      let currentPage = page;
      if (
        (data?.deletePage && onboardingList?.length === 1 && page > 1) ||
        (isFilter && category && data?.statusChange && onboardingList?.length === 1 && page > 1)
      ) {
        currentPage = page - 1;
        setPage(currentPage);
        setPaginationObj({ ...paginationObj, page: currentPage });
      }

      const payload = {
        page: currentPage,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
        endDate: helpers?.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType,
      };
      const path = apiPath.OnboardingList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setOnboardingList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(resultStatus, response.totalPages, null),
        perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs.length, null),
        totalItems: helpers?.ternaryCondition(resultStatus, response.totalDocs, null),
      });
    } catch (error) {
      console.log("error in get all country list==>>>>", error.message);
    }
  };

  const allWithoutOnboarding = async () => {
    try {
      const path = apiPath.OnboardingList;
      const result = await apiGet(path);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setAllOnboardingList(response?.docs);
    } catch (error) {
      console.log("error in get all country list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allWithoutOnboarding();
  }, []);

  useEffect(() => {
    allOnboarding();
  }, [page, filterData, sort]);

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  const handleReset = () => {
    setFilterData({
      category: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isFilter: false,
      isReset: true,
    });
    setPage(1);
    setSearchTerm("");
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    updatePageName(t("HR_ONBOARDING"));
  }, []);

  const getSubscriptionListData = async () => {
    try {
      const res = await apiGet(apiPath.getSubscription, {});
      setSubscriptionData(res?.data?.results);
    } catch (error) {
      console.log("error:", error);
    }
  };

  useEffect(() => {
    getSubscriptionListData();
  }, []);

  return (
    <>
      {" "}
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="flex-wrap col-span-2 flex items-center mb-2 2xl:mb-0">
                <div className="pt-3 flex items-center lg:pt-0 flex-wrap ">
                  <div className="mb-3 relative flex items-center ">
                    <OSearch setSearchTerm={setSearchTerm} placeholder={t("O_SEARCH_BY_NAME_ID_MOBILE")} searchTerm={searchTerm} />
                  </div>
                  <ODateRangePicker isReset={filterData?.isReset} handleDateChange={handleDateChange} setIsReset={setFilterData} />
                  <div className="flex ml-3 mb-3 items-center  ">
                    <select
                      id=""
                      onChange={(e) => statusPage(e)}
                      value={filterData?.category}
                      type="text "
                      name="category"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                    >
                      <option value="">
                        {t("O_ALL")}
                      </option>
                      <option value="active">{t("O_ACTIVE")}</option>
                      <option value="inactive">{t("O_INACTIVE")}</option>
                    </select>
                  </div>

                  <OButton style={{ borderRadius: "0.5rem" }} type="button" onClick={handleReset} label="Reset" extraClasses="ml-3 mb-3" />
                </div>
              </div>
              <div className="flex items-center justify-end px-4 ms-auto mb-3">
                <button
                  title="Add HR onboarding"
                  type="button"
                  className="bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue disabled:hover:bg-[#3B82F680] whitespace-nowrap"
                  onClick={() => handleCategory()}
                >
                  + {t("ADD_HR_ONBOARDING")}
                </button>
              </div>
            </form>
            <OnboardingGeoIps
              role="HRAdmin"
              title={t("GEO_SECTION_HR")}
              help={t("GEO_SECTION_HR_HELP")}
            />
            <HROnboardingList onboardingList={onboardingList} allOnboarding={allOnboarding} page={page} handleEdit={handleEdit} handleView={handleView} currentItem={currentItem} onboardingView={onboardingView} setSort={setSort} sort={sort} />
            {onboardingView && <HROnboardingView onboardingView={onboardingView} currentItem={currentItem} handleView={handleView} allOnboarding={allOnboarding} />}

            {onboardingEdit && <HROnboardingEdit handleEdit={handleEdit} currentItem={currentItem} allOnboarding={allOnboarding} />}

            {/* 2. PASS fetchCompanyCompletionStatus TO THE ADD COMPONENT */}
            {onboardingAdd && (
              <HROnboardingAdd 
                allOnboarding={allOnboarding} 
                onboardingAdd={onboardingAdd} 
                handleCategory={handleCategory} 
                setPage={setPage} 
                refreshCompanyStatus={fetchCompanyCompletionStatus} 
              />
            )}
            
            {helpers.ternaryCondition(paginationObj?.totalItems, <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} />, null)}
          </div>
        </div>
      </div>
    </>
  );
};

export default HROnboardings;

// import React, { useContext, useEffect, useState } from "react";
// import { apiGet } from "../../utils/apiFetch";
// import apiPath from "../../utils/pathObj";
// import OButton from "components/reusable/OButton";
// import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
// import dayjs from "dayjs";
// import Pagination from "../Pagination";
// import AuthContext from "context/AuthContext";
// import { useTranslation } from "react-i18next";
// import HROnboardingList from "./HROnboardingList";
// import HROnboardingAdd from "./HROnboardingAdd";
// import HROnboardingEdit from "./HROnboardingEdit";
// import HROnboardingView from "./HROnboardingView";
// import helpers from "utils/helpers";
// import OSearch from "components/reusable/OSearch";
// import OnboardingGeoIps from "components/geoAccess/OnboardingGeoIps";

// const HROnboardings = () => {
//   const { updatePageName } = useContext(AuthContext);
//   const { t } = useTranslation();
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [paginationObj, setPaginationObj] = useState({
//     page: 1,
//     pageCount: 1,
//     pageRangeDisplayed: 10,
//   });
//   const [onboardingList, setOnboardingList] = useState([]);
//   const [onboardingAllList, setAllOnboardingList] = useState([]);
//   const [onboardingAdd, setOnboardingAdd] = useState(false);
//   const [onboardingEdit, setOnboardingEdit] = useState(false);
//   const [currentItem, setCurrentItem] = useState("");
//   const [onboardingView, setOnboardingView] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
//   const [isInitialized, setIsInitialized] = useState(false);
//   const [subscriptionData, setSubscriptionData] = useState({});

//   const [filterData, setFilterData] = useState({
//     category: "",
//     searchKey: "",
//     startDate: "",
//     endDate: "",
//     isReset: false,
//     isFilter: false,
//   });
//   const [sort, setSort] = useState({
//     sortBy: "createdAt",
//     sortType: "desc",
//   });

//   const handleEdit = (item) => {
//     setCurrentItem(item);
//     setOnboardingEdit(!onboardingEdit);
//   };

//   const handleView = (item) => {
//     setCurrentItem(item);
//     setOnboardingView(!onboardingView);
//   };

//   const handleCategory = () => {
//     setOnboardingAdd(!onboardingAdd);
//   };

//   const handlePageClick = (event) => {
//     const newPage = event.selected + 1;
//     setPage(newPage);
//   };

// const allOnboarding = async (data) => {
//     try {
//       const { category, startDate, endDate, searchKey, isFilter } = filterData;
      
//       // Handle page decrement on delete/status change
//       let currentPage = page;
//       if (
//         (data?.deletePage && onboardingList?.length === 1 && page > 1) ||
//         (isFilter && category && data?.statusChange && onboardingList?.length === 1 && page > 1)
//       ) {
//         currentPage = page - 1;
//         setPage(currentPage);
//         setPaginationObj({ ...paginationObj, page: currentPage });
//       }

//       const payload = {
//         page: currentPage,
//         pageSize,
//         status: category,
//         startDate: helpers?.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
//         endDate: helpers?.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
//         keyword: searchKey,
//         sortBy: sort.sortBy,
//         sortType: sort.sortType,
//       };
//       const path = apiPath.OnboardingList;
//       const result = await apiGet(path, payload);
//       const response = result?.data?.results;
//       const resultStatus = result?.data?.success;
//       console.log("Onboarding List Response", response?.docs);
//       setOnboardingList(response?.docs);
//       setPaginationObj({
//         ...paginationObj,
//         page: helpers?.ternaryCondition(resultStatus, response.page, null),
//         pageCount: helpers?.ternaryCondition(resultStatus, response.totalPages, null),
//         perPageItem: helpers?.ternaryCondition(resultStatus, response?.docs.length, null),
//         totalItems: helpers?.ternaryCondition(resultStatus, response.totalDocs, null),
//       });
//     } catch (error) {
//       console.log("error in get all country list==>>>>", error.message);
//     }
//   };

//   const allWithoutOnboarding = async () => {
//     try {
//       const path = apiPath.OnboardingList;
//       const result = await apiGet(path);
//       const response = result?.data?.results;
//       const resultStatus = result?.data?.success;
//       console.log("resultStatus", resultStatus);
//       setAllOnboardingList(response?.docs);
//     } catch (error) {
//       console.log("error in get all country list==>>>>", error.message);
//     }
//   };

//   useEffect(() => {
//     allWithoutOnboarding();
//   }, []);

//   useEffect(() => {
//     allOnboarding();
//   }, [page, filterData, sort]);

//   useEffect(() => {
//     helpers.setDebouncingFunction({
//       isInitialized,
//       setIsInitialized,
//       debouncedSearchTerm,
//       searchTerm,
//       filterData,
//       setFilterData,
//       setPage,
//     });
//   }, [debouncedSearchTerm]);

//   const handleReset = () => {
//     setFilterData({
//       category: "",
//       searchKey: "",
//       startDate: "",
//       endDate: "",
//       isFilter: false,
//       isReset: true,
//     });
//     setPage(1);
//     setSearchTerm("");
//   };

//   const handleDateChange = (start, end) => {
//     setPage(1);
//     setFilterData({
//       ...filterData,
//       startDate: start,
//       endDate: end,
//       isFilter: true,
//     });
//   };
//   const statusPage = (e) => {
//     setFilterData({ ...filterData, category: e.target.value, isFilter: true });
//     setPage(1);
//   };

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       setDebouncedSearchTerm(searchTerm);
//     }, 500);
//     return () => {
//       clearTimeout(timeoutId);
//     };
//   }, [searchTerm]);

//   useEffect(() => {
//     updatePageName(t("HR_ONBOARDING"));
//   }, []);

//   const getSubscriptionListData = async () => {
//     try {
//       const res = await apiGet(apiPath.getSubscription, {});
//       setSubscriptionData(res?.data?.results);
//     } catch (error) {
//       console.log("error:", error);
//     }
//   };

//   useEffect(() => {
//     getSubscriptionListData();
//   }, []);

//   return (
//     <>
//       {" "}
//       <div className="bg-[#F9F9F9]">
//         <div className="px-3 py-4">
//           <div className="bg-white border border-[#E9EDF9] rounded-lg">
//             <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
//               <div className="flex-wrap col-span-2 flex items-center mb-2 2xl:mb-0">
//                 <div className="pt-3 flex items-center lg:pt-0 flex-wrap ">
//                   <div className="mb-3 relative flex items-center ">
//                     <OSearch setSearchTerm={setSearchTerm} placeholder={t("O_SEARCH_BY_NAME_ID_MOBILE")} searchTerm={searchTerm} />
//                   </div>
//                   <ODateRangePicker isReset={filterData?.isReset} handleDateChange={handleDateChange} setIsReset={setFilterData} />
//                   <div className="flex ml-3 mb-3 items-center  ">
//                     <select
//                       id=""
//                       onChange={(e) => statusPage(e)}
//                       value={filterData?.category}
//                       type="text "
//                       name="category"
//                       className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
//                       placeholder=" "
//                     >
//                       <option value="">
//                         {t("O_ALL")}
//                       </option>
//                       <option value="active">{t("O_ACTIVE")}</option>
//                       <option value="inactive">{t("O_INACTIVE")}</option>
//                     </select>
//                   </div>

//                   <OButton style={{ borderRadius: "0.5rem" }} type="button" onClick={handleReset} label="Reset" extraClasses="ml-3 mb-3" />
//                 </div>
//               </div>
//               <div className="flex items-center justify-end px-4 ms-auto mb-3">
//                 <button
//                   title="Add HR onboarding"
//                   // disabled={filterData?.category === "inactive" || subscriptionData?.noOfHR <= onboardingAllList?.length}
//                   type="button"
//                   className="bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue disabled:hover:bg-[#3B82F680] whitespace-nowrap"
//                   onClick={() => handleCategory()}
//                 >
//                   + {t("ADD_HR_ONBOARDING")}
//                 </button>
//               </div>
//             </form>
//             <OnboardingGeoIps
//               role="HRAdmin"
//               title={t("GEO_SECTION_HR")}
//               help={t("GEO_SECTION_HR_HELP")}
//             />
//             <HROnboardingList onboardingList={onboardingList} allOnboarding={allOnboarding} page={page} handleEdit={handleEdit} handleView={handleView} currentItem={currentItem} onboardingView={onboardingView} setSort={setSort} sort={sort} />
//             {onboardingView && <HROnboardingView onboardingView={onboardingView} currentItem={currentItem} handleView={handleView} allOnboarding={allOnboarding} />}

//             {onboardingEdit && <HROnboardingEdit handleEdit={handleEdit} currentItem={currentItem} allOnboarding={allOnboarding} />}

//             {onboardingAdd && <HROnboardingAdd allOnboarding={allOnboarding} onboardingAdd={onboardingAdd} handleCategory={handleCategory} setPage={setPage} />}
//             {helpers.ternaryCondition(paginationObj?.totalItems, <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} />, null)}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default HROnboardings;
